module.exports = __webpack_public_path__ + "static/media/sport-industry.4e45d3e0.svg";